var _path, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.938 1.94l-5.999 6a1.5 1.5 0 002.122 2.12L16.5 6.622V22.5a1.5 1.5 0 003 0V6.621l3.44 3.44a1.5 1.5 0 002.12-2.122L19.063 1.94a1.495 1.495 0 00-1.636-.326 1.494 1.494 0 00-.488.326zM4.5 18v12A4.5 4.5 0 009 34.5h18a4.5 4.5 0 004.5-4.5V18a1.5 1.5 0 00-3 0v12a1.5 1.5 0 01-1.5 1.5H9A1.5 1.5 0 017.5 30V18a1.5 1.5 0 00-3 0z",
    fill: "#777E8C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "share_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 28,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.938 1.94l-5.999 6a1.5 1.5 0 002.122 2.12L16.5 6.622V22.5a1.5 1.5 0 003 0V6.621l3.44 3.44a1.5 1.5 0 002.12-2.122L19.063 1.94a1.495 1.495 0 00-1.636-.326 1.494 1.494 0 00-.488.326zM4.5 18v12A4.5 4.5 0 009 34.5h18a4.5 4.5 0 004.5-4.5V18a1.5 1.5 0 00-3 0v12a1.5 1.5 0 01-1.5 1.5H9A1.5 1.5 0 017.5 30V18a1.5 1.5 0 00-3 0z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "a2bf2f025763ae8db260c38723976569.svg";
export { SvgShare as ReactComponent };